import React from 'react';
import { Component } from 'react';
import { NavLink } from 'react-router-dom';
import logo from "../../assets/logo.svg";
import "./navbar.css";
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import PrivateRoute from "../private_route/PrivateRoute";


function User(props) {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const handleSignout = () => {
    const setUserAction = {
      type: 'user/setUser',
      payload: null,
    };
    dispatch(setUserAction);
    document.getElementById("signInDiv").hidden = false;
  }
  return(
      user && 
      <div className="lpm__user_avatar">
        <div>
        <img className="lpm__user_avatar-circle_image" src={user.picture}></img>
        </div>
        <div className="lpm__user_avatar_info">
          <label>{user.name}</label>
          <label>{user.email}</label>
        </div>
        <div>
          <button class="lpm__signout_button" role="button" onClick={handleSignout}>Sign Out</button>
        </div>
      </div>
  );
}



class NavBar extends Component {

  state = { clicked: false };

  handleClick = () =>{
    this.setState({clicked: !this.state.clicked});
  };

  render() {
    
    return (
      <nav className="lpm__nav">
      <a href="#" class="logo">
        <img src={logo} alt="Logo" />
      </a>
      <div>
        <ul className={this.state.clicked ? "lpm__nav--navbar active" : "lpm__nav--navbar"}>
          <PrivateRoute>
            <li className="lpm__nav--list"><NavLink className={({ isActive }) => isActive ? "lpm__nav--link-active" : "lpm__nav--link"} to="/home"><i id="nav-icon" class="fa-sharp fa-solid fa-house fa-xs"></i>Home</NavLink></li>
            <li className="lpm__nav--list"><NavLink className={({ isActive }) => isActive ? "lpm__nav--link-active" : "lpm__nav--link"} to="/funds"><i id="nav-icon" class="fa-sharp fa-solid fa-dollar-sign fa-xs"></i>Funds</NavLink></li>
            <li className="lpm__nav--list"><NavLink className={({ isActive }) => isActive ? "lpm__nav--link-active" : "lpm__nav--link"} to="/portfolio-companies"><i id="nav-icon" class="fa-sharp fa-solid fa-city fa-xs"></i>Portfolio Companies</NavLink></li>
            <li className="lpm__nav--list"><NavLink className={({ isActive }) => isActive ? "lpm__nav--link-active" : "lpm__nav--link"} to="/investments"><i id="nav-icon" class="fa-sharp fa-solid fa-layer-group fa-xs"></i>Investments</NavLink></li>
            <li className="lpm__nav--list"><NavLink className={({ isActive }) => isActive ? "lpm__nav--link-active" : "lpm__nav--link"} to="/dashboard"><i id="nav-icon" class="fa-sharp fa-solid fa-chart-line fa-xs"></i>Dashboard</NavLink></li>
          </PrivateRoute>
          <div>
            <div id="signInDiv"></div>
            <User />
          </div>
        </ul>
        
      </div>
      <div id="mobile" onClick={this.handleClick}>
        <i id="bar" className={this.state.clicked?"fas fa-times" : "fas fa-bars"}></i>
      </div>
      
    </nav>
    );
  }
}

export default NavBar;